(function () {
  window.theme = window.theme || {};
  window.theme.i18n = window.theme.i18n || {};

  function escapeHtml(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function translate(key, fallback, vars = {}) {
    const value = key.split('.').reduce((obj, part) => obj && obj[part], window.theme?.i18n);
    const template = typeof value === 'string' && value.length ? value : fallback;

    return String(template).replace(/{{\s*(\w+)\s*}}/g, (_, name) => {
      const v = vars[name];
      return v === undefined || v === null ? '' : String(v);
    });
  }
  
  /* ------------------------------------------------------------------------------------------
    AJAX ADD TO CART
------------------------------------------------------------------------------------------ */
(function () {
  'use strict';

  const ADD_URL = '/cart/add.js';
  const CART_JSON_URL = '/cart.js';

  // Default loader
  const LOADER_SVG_URL = window.theme.loaderUrl;

  // Loader used for buttons with class "product-page"
  const PDP_LOADER_SVG_URL =
    (window.theme && window.theme.loaderUrlWhite) || LOADER_SVG_URL;

  function qs(sel, ctx = document) {
    return (ctx || document).querySelector(sel);
  }

  function qsa(sel, ctx = document) {
    return Array.from((ctx || document).querySelectorAll(sel));
  }

  function createEl(tag, props = {}) {
    const el = document.createElement(tag);
    Object.assign(el, props);
    return el;
  }

  let _live = qs('#ajax-add-cart-live');
  if (!_live) {
    _live = createEl('div', { id: 'ajax-add-cart-live' });
    _live.setAttribute('aria-live', 'polite');
    _live.setAttribute('aria-atomic', 'true');
    _live.className = 'sr-only';
    document.body.appendChild(_live);
  }

  function getCheckoutUrl() {
    const el1 = qs('[data-checkout-url]');
    if (el1) return el1.getAttribute('data-checkout-url') || '/checkout';

    const el2 = qs('#cart-checkout-url') || qs('[data-cart-checkout-url]');
    if (el2) return el2.getAttribute('href') || el2.getAttribute('data-cart-checkout-url') || '/checkout';

    return '/checkout';
  }

  function getMessagesContainer() {
    let container = qs('#cart-messages');
    if (container) {
      container.classList.remove('flex', 'items-end', 'justify-end');
      container.classList.add(
        'fixed',
        'right-0',
        'bottom-0',
        'pointer-events-none',
        'z-[9999]',
        'flex',
        'flex-col',
        'items-end',
        'justify-end',
        'gap-2',
        'p-2',
        'md:p-3',
        'max-w-full'
      );
      return container;
    }

    container = createEl('div', { id: 'cart-messages' });
    container.className = 'fixed right-0 bottom-0 pointer-events-none z-[9999] flex flex-col items-end justify-end gap-2 p-2 md:p-3 max-w-full';
    document.body.appendChild(container);
    return container;
  }

  window.closeMessage = function (btn) {
    try {
      const toast = btn.closest('.cart-snackbar');
      if (!toast) return;

      if (toast._autoDismissTimeout) clearTimeout(toast._autoDismissTimeout);

      toast.classList.remove('translate-x-0', 'opacity-100');
      toast.classList.add('translate-x-full', 'opacity-0');

      setTimeout(() => {
        if (toast && toast.parentNode) toast.parentNode.removeChild(toast);
      }, 320);
    } catch (e) {
      /* ignore */
    }
  };

  function showSnackbarForItem(opts = {}) {
    const {
      title = 'Item',
      qty = 1,
      img = '',
      checkoutUrl = getCheckoutUrl(),
      duration = 4500
    } = opts;

    const container = getMessagesContainer();

    const wrapper = createEl('div', {
      className: [
        'cart-snackbar',
        'theme-lighter',
        'border-light',
        'border',
        'text-xs',
        'flex',
        'gap-4',
        'font-medium',
        'rounded-md',
        'p-2',
        'pe-0',
        'inline-flex',
        'items-center',
        'pointer-events-auto',
        'max-w-md',
        'transform',
        'transition-all',
        'duration-300',
        'ease-in-out',
        'translate-x-4',
        'opacity-0'
      ].join(' ')
    });

    const imgWrap = createEl('div', {
      className: 'w-[45px] h-[45px] p-2 rounded-lg card-bg flex items-center justify-center overflow-hidden flex-none'
    });

    if (img) {
      const im = createEl('img', {
        src: img,
        alt: title || 'Product',
        className: 'w-full h-full object-contain'
      });
      imgWrap.appendChild(im);
    } else {
      imgWrap.innerHTML = '<div class="w-full h-full bg-neutral-200"></div>';
    }

    const msgCol = createEl('div', { className: 'min-w-0 flex-1' });

    const addedText = translate(
      'cart-ajax.added_to_cart',
      '{{ qty }} x {{ title }} was added to cart.',
      { qty, title }
    );

    const p = createEl('p', { className: 'font-semibold', textContent: addedText });
    const a = createEl('a', {
      className: 'text-neutral-500 inline-block mt-1',
      href: checkoutUrl,
      textContent: translate('cart-ajax.checkout', 'Checkout')
    });

    msgCol.appendChild(p);
    msgCol.appendChild(a);

    const closeBtn = createEl('button', {
      className: 'w-12 h-12 flex items-center justify-center flex-none',
      type: 'button',
      innerHTML: '<span class="i-icon i-close text-lg" aria-hidden="true"></span>'
    });
    closeBtn.setAttribute('onclick', 'closeMessage(this);');
    closeBtn.setAttribute('aria-label', translate('cart-ajax.close_message', 'Close message'));

    wrapper.appendChild(imgWrap);
    wrapper.appendChild(msgCol);
    wrapper.appendChild(closeBtn);

    container.appendChild(wrapper);

    requestAnimationFrame(() => {
      wrapper.classList.remove('translate-x-4', 'opacity-0');
      wrapper.classList.add('translate-x-0', 'opacity-100');
    });

    const timeoutId = setTimeout(() => {
      wrapper.classList.remove('translate-x-0', 'opacity-100');
      wrapper.classList.add('translate-x-full', 'opacity-0');
      setTimeout(() => {
        if (wrapper && wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
      }, 320);
    }, duration);

    wrapper._autoDismissTimeout = timeoutId;
    return wrapper;
  }

  function createLoaderImg(size = 25, url = LOADER_SVG_URL) {
    const img = createEl('img', {
      src: url,
      alt: '',
      width: size,
      height: size,
      className: 'inline-block align-middle'
    });

    img.setAttribute('aria-hidden', 'true');
    return img;
  }

  function createCheckIcon(size = 18) {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', String(size));
    svg.setAttribute('height', String(size));
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('inline-block', 'align-middle');

    const path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M20 6L9 17l-5-5');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2.5');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');

    svg.appendChild(path);
    return svg;
  }

  function setButtonLoading(btn, isLoading) {
    if (!btn) return;

    if (isLoading) {
      clearTimeout(btn._successTimer);
      btn.dataset._origHtml = btn.innerHTML;
      delete btn.dataset._successState;

      btn.disabled = true;
      btn.classList.add('pointer-events-none');
      btn.innerHTML = '';

      const isPdp = btn.classList.contains('product-page');
      const loader = isPdp
        ? createLoaderImg(24, PDP_LOADER_SVG_URL)
        : createLoaderImg(18, LOADER_SVG_URL);

      btn.appendChild(loader);

      const span = createEl('span', {
        textContent: '',
        className: 'hidden'
      });
      btn.appendChild(span);
    } else {
      btn.disabled = false;
      btn.classList.remove('pointer-events-none');

      if (btn.dataset._origHtml) {
        btn.innerHTML = btn.dataset._origHtml;
        delete btn.dataset._origHtml;
      }
    }
  }

  function setButtonSuccess(btn) {
    if (!btn) return;

    clearTimeout(btn._successTimer);
    btn.dataset._successState = '1';

    btn.disabled = true;
    btn.classList.add('pointer-events-none');
    btn.innerHTML = '';

    const check = createCheckIcon(18);
    btn.appendChild(check);

    const span = createEl('span', {
      textContent: '',
      className: 'hidden'
    });
    btn.appendChild(span);
  }

  function restoreButton(btn) {
    if (!btn) return;

    clearTimeout(btn._successTimer);
    btn.disabled = false;
    btn.classList.remove('pointer-events-none');

    if (btn.dataset._origHtml) {
      btn.innerHTML = btn.dataset._origHtml;
      delete btn.dataset._origHtml;
    }

    delete btn.dataset._successState;
  }

  async function refreshCartUI() {
    if (window.CartDrawerAjax && typeof window.CartDrawerAjax.refresh === 'function') {
      try {
        await window.CartDrawerAjax.refresh();
      } catch (e) {
        /* ignore */
      }
    } else {
      try {
        const res = await fetch(CART_JSON_URL, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) return;

        const cart = await res.json();

        qsa('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });

        qsa('[data-cart-total]').forEach(el => {
          if (window.Shopify && window.Shopify.formatMoney) {
            el.textContent = Shopify.formatMoney(cart.total_price);
          } else {
            el.textContent = (cart.total_price / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
          }
        });

        const badge = qs('#cart-items');
        if (badge) {
          badge.textContent = cart.item_count;
          if (Number(cart.item_count) === 0) badge.classList.add('hidden');
          else badge.classList.remove('hidden');
        }
      } catch (e) {
        /* ignore */
      }
    }
  }

  function parsePropertiesAttr(str) {
    if (!str) return null;

    try {
      return JSON.parse(str);
    } catch (e) {
      const obj = {};
      str.split(';').forEach(pair => {
        const [k, v] = pair.split('=').map(s => s && s.trim());
        if (k) obj[k] = v || '';
      });
      return obj;
    }
  }

  async function ajaxAddToCart(payload) {
    const res = await fetch(ADD_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const text = await res.text();
      try {
        const json = JSON.parse(text);
        throw new Error(json.description || json.message || translate('cart-ajax.add_to_cart_failed', 'Add to cart failed'));
      } catch (e) {
        throw new Error(text || translate('cart-ajax.add_to_cart_failed', 'Add to cart failed'));
      }
    }

    return res.json();
  }

  document.addEventListener('click', async (ev) => {
    const btn = ev.target.closest('.ajax-add-to-cart');
    if (!btn) return;

    const form = btn.closest('form') || {};
    ev.preventDefault();

    const variantId = btn.dataset.variantId || (form.querySelector && form.querySelector('input[name="id"]')?.value);
    let qty = Number(btn.dataset.quantity || (form.querySelector && form.querySelector('input[name="quantity"]')?.value) || 1);
    if (!Number.isInteger(qty) || qty < 1) qty = 1;

    if (!variantId) {
      console.warn('No variant id found for AJAX add-to-cart');
      if (form && form.submit) form.submit();
      return;
    }

    const payload = { id: variantId, quantity: qty };

    const propsAttr = btn.getAttribute('data-properties') || (form.getAttribute && form.getAttribute('data-properties'));
    const propsObj = parsePropertiesAttr(propsAttr);
    if (propsObj && Object.keys(propsObj).length) payload.properties = propsObj;

    setButtonLoading(btn, true);

    try {
      const added = await ajaxAddToCart(payload);

      _live.textContent = added && added.title
        ? translate('cart-ajax.added_to_cart_live', 'Added {{ title }} to cart', { title: added.title })
        : translate('cart-ajax.added_to_cart_short', 'Added to cart');

      let imageSrc = '';
      if (added) {
        if (typeof added.image === 'string' && added.image) imageSrc = added.image;
        else if (added.image && typeof added.image.src === 'string') imageSrc = added.image.src;
        else if (added.featured_image) imageSrc = added.featured_image;
      }

      setButtonSuccess(btn);

      btn._successTimer = setTimeout(() => {
        restoreButton(btn);
      }, 2000);

      openCart();

      // showSnackbarForItem({
      //   title: (added && added.title) ? added.title : translate('cart-ajax.item', 'Item'),
      //   qty: qty,
      //   img: imageSrc,
      //   checkoutUrl: getCheckoutUrl(),
      //   duration: 4500
      // });

      await refreshCartUI();
    } catch (err) {
      console.error('Add to cart error', err);

      const msg = err && err.message
        ? err.message
        : translate('cart-ajax.could_not_add_to_cart', 'Could not add to cart');

      _live.textContent = msg;

      const errorWrapper = createEl('div', {
        className: [
          'cart-snackbar',
          'theme-lighter',
          'border-neutral-100',
          'border',
          'text-xs',
          'flex',
          'gap-4',
          'font-medium',
          'rounded-md',
          'p-2',
          'pe-0',
          'inline-flex',
          'items-center',
          'pointer-events-auto',
          'max-w-md',
          'bg-red-600',
          'text-white',
          'transform',
          'transition-all',
          'duration-300',
          'ease-in-out',
          'translate-x-4',
          'opacity-0'
        ].join(' ')
      });

      const errorMsg = createEl('div', {
        className: 'min-w-0 flex-1 font-semibold',
        textContent: msg
      });

      const errClose = createEl('button', {
        className: 'w-10 h-10 flex items-center justify-center flex-none',
        type: 'button',
        innerHTML: '<span class="i-icon i-close text-md" aria-hidden="true"></span>'
      });

      errClose.setAttribute('onclick', 'closeMessage(this);');
      errClose.setAttribute('aria-label', translate('cart-ajax.close_message', 'Close message'));

      errorWrapper.appendChild(errorMsg);
      errorWrapper.appendChild(errClose);
      getMessagesContainer().appendChild(errorWrapper);

      requestAnimationFrame(() => {
        errorWrapper.classList.remove('translate-x-4', 'opacity-0');
        errorWrapper.classList.add('translate-x-0', 'opacity-100');
      });

      errorWrapper._autoDismissTimeout = setTimeout(() => {
        errorWrapper.classList.remove('translate-x-0', 'opacity-100');
        errorWrapper.classList.add('translate-x-full', 'opacity-0');
        setTimeout(() => {
          if (errorWrapper && errorWrapper.parentNode) errorWrapper.parentNode.removeChild(errorWrapper);
        }, 320);
      }, 6000);
    } finally {
      if (btn.dataset._successState !== '1') {
        setButtonLoading(btn, false);
      }
    }
  }, { passive: false });
  })();
})();


  /* ------------------------------------------------------------------------------------------
    PRODUCT PAGE
------------------------------------------------------------------------------------------ */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="bundle-purchase-"]').forEach(initBundlePurchase);
});

function initBundlePurchase(root) {
  if (!root) return;

  const productIdMatch = root.id.match(/^bundle-purchase-(\d+)$/);
  const productId = productIdMatch ? productIdMatch[1] : root.dataset.productId || '';

  const configEl = productId ? document.getElementById(`bundle-data-${productId}`) : null;
  let config = {};

  if (configEl) {
    try {
      config = JSON.parse(configEl.textContent.trim());
    } catch (error) {
      console.error('[Bundle ATC] Invalid JSON config:', error);
    }
  }

  const input = root.querySelector(productId ? `#quantity-${productId}` : 'input[name="quantity"]');
  const minus = root.querySelector('[data-qty-minus]');
  const plus = root.querySelector('[data-qty-plus]');
  const radios = Array.from(root.querySelectorAll('.purchase-option'));
  const optionLabels = Array.from(root.querySelectorAll('[data-purchase-option]'));

  const priceEl = root.querySelector('#atc-price');
  const priceSeparatorEl = root.querySelector('#atc-price-separator');
  const atcLabel = root.querySelector('#atc-label');

  const productForm = root.querySelector('.product-form');
  const submitButton = productForm ? productForm.querySelector('button[type="submit"]') : null;

  const purchaseTypeButtons = Array.from(root.querySelectorAll('[data-purchase-type-btn]'));
  const purchaseTypeRadios = Array.from(root.querySelectorAll('input[name="purchase_type"]'));

  const bundleOptions = root.querySelector('#bundle-options');
  const subscriptionPanel = productId
    ? root.querySelector(`#subscription-panel-${productId}`)
    : root.querySelector('[data-subscription-panel]');
  const frequencySelect = root.querySelector('[data-frequency-select]');
  const subscriptionEmbed = document.querySelector('.subscriptions_app_embed_block');
  const sellingPlanInput = root.querySelector('#bundle-selling-plan');

  const bulkTextEl = productId ? root.querySelector(`#bulk-text-${productId}`) : null;
  const subTextEl = productId ? root.querySelector(`#sub-text-${productId}`) : null;

  const variantPrice = Number(config.variantPrice || root.dataset.variantPrice || 0);
  const defaultSellingPlanId = String(config.defaultSellingPlanId || root.dataset.defaultSellingPlanId || '');
  const subscriptionPlanPrices = config.subscriptionPlanPrices || {};

  const i18n = {
    addToCart: config?.i18n?.addToCart || 'Lägg i varukorgen',
    subscribe: config?.i18n?.subscribe || 'Prenumerera',
    adding: config?.i18n?.adding || 'Lägger till…',
    added: config?.i18n?.added || 'Tillagd'
  };

  const LOADER_SVG_URL = window.theme?.loaderUrl || '';
  const PDP_LOADER_SVG_URL = window.theme?.loaderUrlWhite || LOADER_SVG_URL;

  const tiers = radios
    .map((radio) => ({
      qty: parseInt(radio.dataset.qty, 10),
      discount: parseInt(radio.dataset.discount || '0', 10)
    }))
    .filter((tier) => Number.isFinite(tier.qty))
    .sort((a, b) => a.qty - b.qty);

  let embedSyncTimer = null;
  let isBusy = false;

  const formatSEK = (cents) => {
    const rounded = Math.round((Number(cents) || 0) / 100);
    return rounded.toLocaleString('sv-SE') + ' SEK';
  };

  const getTierForQty = (qty) => {
    const n = Math.max(1, parseInt(qty, 10) || 1);
    if (!tiers.length) return n;

    let selected = tiers[0].qty;

    for (const tier of tiers) {
      if (n >= tier.qty) selected = tier.qty;
      else break;
    }

    return selected;
  };

  const getDiscountForTier = (tierQty) => {
    const tier = tiers.find((t) => t.qty === tierQty);
    return tier ? tier.discount : 0;
  };

  const getSelectedPurchaseType = () => {
    const checked = root.querySelector('input[name="purchase_type"]:checked');
    return checked ? checked.value : 'onetime';
  };

  const getSelectedOption = () => root.querySelector('.purchase-option:checked');

  // ---- Bulk mix: one product picker per item in the active bulk box (2+ items, one-time purchase).
  // Products from #bulk-mix-{productId} (snippets/bundle-data.liquid); the current product is first and the
  // default. Choices are kept per position while the quantity changes. ----
  let mixProducts = [];
  const mixEl = productId ? document.getElementById(`bulk-mix-${productId}`) : null;
  if (mixEl) {
    try { mixProducts = JSON.parse(mixEl.textContent.trim()) || []; } catch (error) { mixProducts = []; }
  }
  const MIX_MAX = 12;
  const mixChoices = [];
  const mixReadMore = mixEl?.dataset.readMore || 'Läs mer';
  const mixById = new Map(mixProducts.map((p) => [String(p.id), p]));
  const mixDialog = productId ? document.getElementById(`bulk-mix-dialog-${productId}`) : null;
  const MIX_CHEVRON = '<svg class="bulk-pick__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  function activePicksEl() {
    const option = getSelectedOption();
    const wrap = option ? option.closest('[data-bulk-option]') : null;
    return wrap ? wrap.querySelector('[data-bulk-picks]') : null;
  }

  function mixActive() {
    if (mixProducts.length < 2 || getSelectedPurchaseType() === 'subscription') return false;
    const qty = Math.max(1, parseInt(input?.value || '1', 10) || 1);
    return qty >= 2 && qty <= MIX_MAX && !!activePicksEl();
  }

  function mixLabel(index) {
    const text = mixEl?.dataset.mixLabel || '';
    return text ? text.replace('__index__', index) : String(index);
  }

  // Price per item in the current bulk tier
  function mixUnitCents(p) {
    const discount = getDiscountForTier(getTierForQty(input?.value || 1));
    return Math.round((Number(p.price) || 0) * (100 - discount) / 100);
  }

  // Image, title and price per item (button and options)
  function fillRow(el, p) {
    el.innerHTML = '<span class="bulk-pick__img"></span>' +
      '<span class="bulk-pick__text"><span class="bulk-pick__title"></span><span class="bulk-pick__price"></span></span>';
    if (p.image) {
      const img = document.createElement('img');
      img.src = p.image;
      img.alt = '';
      img.width = 40;
      img.height = 40;
      img.loading = 'lazy';
      img.className = 'bulk-pick__img';
      el.firstChild.replaceWith(img);
    }
    el.querySelector('.bulk-pick__title').textContent = p.title;
    el.querySelector('.bulk-pick__price').textContent = `${formatSEK(mixUnitCents(p))} / st`;
  }

  function openMixInfo(variantId) {
    if (!mixDialog) return;
    const tpl = document.querySelector(`template[data-mix-info="${variantId}"]`);
    const body = mixDialog.querySelector('[data-mix-dialog-body]');
    if (!tpl || !body) return;
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    if (typeof mixDialog.showModal === 'function') mixDialog.showModal();
    else mixDialog.setAttribute('open', '');
  }
  if (mixDialog) {
    // Click on the backdrop closes
    mixDialog.addEventListener('click', (event) => { if (event.target === mixDialog) mixDialog.close(); });
  }

  // One custom select (listbox): button showing image + title + price per item, options with the same,
  // and a "Läs mer" button for the chosen product. Keyboard: arrows / Home / End move, Enter / Space pick,
  // Esc / Tab close.
  let openPicker = null;
  function closePicker(focusTrigger) {
    if (!openPicker) return;
    const { trigger, list } = openPicker;
    list.classList.add('hidden');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.removeAttribute('aria-activedescendant');
    if (focusTrigger) trigger.focus();
    openPicker = null;
  }
  document.addEventListener('click', (event) => {
    if (openPicker && !openPicker.field.contains(event.target)) closePicker(false);
  });

  function buildPicker(i) {
    const base = `bulk-pick-${productId}-${i}`;
    const field = document.createElement('div');
    field.className = 'bulk-pick';
    field.innerHTML =
      `<span id="${base}-label" class="sr-only"></span>` +
      '<div class="bulk-pick__row">' +
        `<button type="button" id="${base}" class="bulk-pick__trigger" aria-haspopup="listbox" aria-expanded="false" aria-controls="${base}-list" aria-labelledby="${base}-label ${base}"><span class="bulk-pick__current" data-mix-current></span>${MIX_CHEVRON}</button>` +
        '<button type="button" class="bulk-pick__more" data-mix-more></button>' +
      '</div>' +
      `<ul id="${base}-list" role="listbox" tabindex="-1" aria-labelledby="${base}-label" class="bulk-pick__list hidden" data-lenis-prevent></ul>`;
    field.querySelector(`#${base}-label`).textContent = mixLabel(i + 1);

    const trigger = field.querySelector(`#${base}`);
    const current = field.querySelector('[data-mix-current]');
    const list = field.querySelector('ul');
    const more = field.querySelector('[data-mix-more]');
    more.textContent = mixReadMore;

    mixProducts.forEach((p, n) => {
      const li = document.createElement('li');
      li.id = `${base}-opt-${n}`;
      li.setAttribute('role', 'option');
      li.dataset.value = String(p.id);
      li.className = 'bulk-pick__option';
      fillRow(li, p);
      li.addEventListener('click', () => choose(String(p.id)));
      list.appendChild(li);
    });
    const options = Array.from(list.children);

    function sync() {
      const p = mixById.get(mixChoices[i]) || mixProducts[0];
      fillRow(current, p);
      options.forEach((li) => {
        li.setAttribute('aria-selected', li.dataset.value === String(p.id) ? 'true' : 'false');
        const op = mixById.get(li.dataset.value);
        if (op) li.querySelector('.bulk-pick__price').textContent = `${formatSEK(mixUnitCents(op))} / st`;
      });
      more.setAttribute('aria-label', `${mixReadMore}: ${p.title}`);
    }
    function choose(value) {
      mixChoices[i] = value;
      sync();
      closePicker(true);
      updateAtcPrice();
    }
    let focusIndex = 0;
    function setFocus(n) {
      focusIndex = (n + options.length) % options.length;
      options.forEach((li, k) => li.classList.toggle('is-focus', k === focusIndex));
      trigger.setAttribute('aria-activedescendant', options[focusIndex].id);
      options[focusIndex].scrollIntoView({ block: 'nearest' });
    }
    function open() {
      if (openPicker && openPicker.field !== field) closePicker(false);
      list.classList.remove('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      openPicker = { field, trigger, list };
      setFocus(Math.max(0, options.findIndex((li) => li.dataset.value === mixChoices[i])));
    }

    trigger.addEventListener('click', () => (openPicker && openPicker.field === field ? closePicker(true) : open()));
    trigger.addEventListener('keydown', (event) => {
      const isOpen = openPicker && openPicker.field === field;
      if (['ArrowDown', 'ArrowUp'].includes(event.key)) {
        event.preventDefault();
        if (!isOpen) open();
        else setFocus(focusIndex + (event.key === 'ArrowDown' ? 1 : -1));
      } else if (isOpen && (event.key === 'Home' || event.key === 'End')) {
        event.preventDefault();
        setFocus(event.key === 'Home' ? 0 : options.length - 1);
      } else if (isOpen && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        choose(options[focusIndex].dataset.value);
      } else if (isOpen && event.key === 'Escape') {
        event.preventDefault();
        closePicker(true);
      } else if (isOpen && event.key === 'Tab') {
        closePicker(false);
      }
    });
    more.addEventListener('click', () => openMixInfo(mixChoices[i]));

    field.__sync = sync;
    sync();
    return field;
  }

  function renderPicks() {
    const active = mixActive() ? activePicksEl() : null;
    root.querySelectorAll('[data-bulk-picks]').forEach((el) => {
      if (el !== active) {
        el.classList.add('hidden');
        el.innerHTML = '';
      }
    });
    if (!active) {
      closePicker(false);
      return;
    }

    const qty = Math.max(1, parseInt(input?.value || '1', 10) || 1);
    active.classList.remove('hidden');

    const fields = Array.from(active.children);
    if (fields.length === qty) {
      fields.forEach((f) => f.__sync && f.__sync()); // prices follow the tier
      return;
    }

    closePicker(false);
    active.innerHTML = '';
    for (let i = 0; i < qty; i++) {
      if (!mixChoices[i]) mixChoices[i] = String(mixProducts[0].id);
      active.appendChild(buildPicker(i));
    }
  }

  // [{ id, quantity }] from the pickers, same products merged
  function mixItems() {
    const qty = Math.max(1, parseInt(input?.value || '1', 10) || 1);
    const counts = new Map();
    for (let i = 0; i < qty; i++) {
      const id = mixChoices[i] || String(mixProducts[0].id);
      counts.set(id, (counts.get(id) || 0) + 1);
    }
    return Array.from(counts, ([id, quantity]) => ({ id: Number(id), quantity }));
  }

  function mixPriceCents() {
    const discount = getDiscountForTier(getTierForQty(input?.value || 1));
    const sum = mixItems().reduce((total, item) => total + (Number(mixById.get(String(item.id))?.price) || 0) * item.quantity, 0);
    return Math.round(sum * (100 - discount) / 100);
  }

  function setPurchaseType(type) {
    const nextType = type === 'subscription' ? 'subscription' : 'onetime';

    purchaseTypeRadios.forEach((radio) => {
      radio.checked = radio.value === nextType;
    });

    purchaseTypeButtons.forEach((btn) => {
      const active = btn.dataset.purchaseTypeBtn === nextType;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.classList.toggle('bg-white', active);
      btn.classList.toggle('text-dark', active);
    });

    setQty(1);
    updatePurchaseTypeUI();
  }

  function syncPurchaseTypeTabOrder() {
    purchaseTypeButtons.forEach((btn) => {
      btn.tabIndex = 0;
    });
  }

  function setSellingPlan(value) {
    if (!sellingPlanInput) return false;

    const id = parseInt(value, 10);

    if (Number.isFinite(id) && id > 0) {
      sellingPlanInput.value = String(id);
      sellingPlanInput.disabled = false;
      return true;
    }

    sellingPlanInput.value = '';
    sellingPlanInput.disabled = true;
    return false;
  }

  function getSelectedFrequencyOption() {
    if (!frequencySelect) return null;
    return frequencySelect.options[frequencySelect.selectedIndex] || frequencySelect.options[0] || null;
  }

  function getSelectedSellingPlanId() {
    const current = parseInt(sellingPlanInput?.value || '', 10);
    if (Number.isFinite(current) && current > 0) return current;

    const fallback = parseInt(defaultSellingPlanId || '', 10);
    if (Number.isFinite(fallback) && fallback > 0) return fallback;

    const option = getSelectedFrequencyOption();
    if (option) {
      const fromValue = parseInt(option.value || option.dataset.planId || '', 10);
      if (Number.isFinite(fromValue) && fromValue > 0) return fromValue;
    }

    return null;
  }

  function setSubscriptionFallback() {
    return setSellingPlan(defaultSellingPlanId);
  }

  function getSubscriptionUnitPrice() {
    const option = getSelectedFrequencyOption();

    if (option) {
      const fromOption = Number(option.dataset.planPrice);
      if (Number.isFinite(fromOption) && fromOption > 0) return fromOption;
    }

    const planId = getSelectedSellingPlanId();
    if (!planId) return null;

    const raw = subscriptionPlanPrices[String(planId)];
    const price = Number(raw);

    return Number.isFinite(price) && price > 0 ? price : null;
  }

  function ensureSubscriptionSelection() {
    if (!frequencySelect || !frequencySelect.options.length) {
      return setSubscriptionFallback();
    }

    const option = getSelectedFrequencyOption() || frequencySelect.options[0];
    if (!option) {
      return setSubscriptionFallback();
    }

    const planId = parseInt(option.value || option.dataset.planId || '', 10);
    if (!Number.isFinite(planId) || planId <= 0) {
      return setSubscriptionFallback();
    }

    frequencySelect.value = String(planId);
    return setSellingPlan(planId);
  }

  function syncSubscriptionStateFromSelect() {
    if (!frequencySelect || !frequencySelect.options.length) {
      return setSubscriptionFallback();
    }

    const option = getSelectedFrequencyOption();
    if (!option) return setSubscriptionFallback();

    const planId = parseInt(option.value || option.dataset.planId || '', 10);
    if (!Number.isFinite(planId) || planId <= 0) {
      return setSubscriptionFallback();
    }

    frequencySelect.value = String(planId);
    return setSellingPlan(planId);
  }

  function updateBundleRowPrices() {
    optionLabels.forEach((label) => {
      const radio = label.querySelector('.purchase-option');
      if (!radio) return;

      const qty = parseInt(radio.dataset.qty, 10) || 1;
      const totalCents = parseInt(radio.dataset.optionTotalCents || '', 10);
      const unitCents = parseInt(radio.dataset.unitPriceCents || '', 10);
      const compareCents = parseInt(radio.dataset.optionCompareCents || '', 10);

      const fallbackDiscount = parseInt(radio.dataset.discount || '0', 10);
      const fallbackTotal = Math.round(variantPrice * qty * (100 - fallbackDiscount) / 100);
      const resolvedTotal = Number.isFinite(totalCents) && totalCents > 0 ? totalCents : fallbackTotal;
      const resolvedUnit = Number.isFinite(unitCents) && unitCents > 0
        ? unitCents
        : Math.round(resolvedTotal / qty);

      const totalEl = label.querySelector('[data-option-total="1"]');
      const compareEl = label.querySelector('[data-option-compare]');
      const unitEl = label.querySelector(`[data-option-unit="${qty}"]`);

      if (compareEl && Number.isFinite(compareCents) && compareCents > 0) {
        compareEl.textContent = formatSEK(compareCents);
      }

      if (totalEl) totalEl.textContent = formatSEK(resolvedTotal);
      if (unitEl) unitEl.textContent = `${formatSEK(resolvedUnit)} / st`;
    });
  }

  function syncPurchaseOptionState(activeRadio) {
    optionLabels.forEach((label) => {
      const radio = label.querySelector('.purchase-option');
      if (!radio) return;

      const isActive = radio === activeRadio;
      label.classList.toggle('active', isActive);
      const box = label.closest('[data-bulk-option]');
      if (box) box.classList.toggle('is-active', isActive);
      label.setAttribute('aria-checked', isActive ? 'true' : 'false');
      radio.checked = isActive;

      const dotOuter = label.querySelector('[data-option-dot]');
      const dotInner = dotOuter ? dotOuter.querySelector('span') : null;

      if (dotInner) {
        dotInner.classList.toggle('opacity-100', isActive);
        dotInner.classList.toggle('opacity-0', !isActive);
      }
    });
  }

  const hideAtcPrice = (hide) => {
    if (priceEl) priceEl.classList.toggle('hidden', !!hide);
    if (priceSeparatorEl) priceSeparatorEl.classList.toggle('hidden', !!hide);
  };

  function getSelectedOptionUnitCents() {
    const option = getSelectedOption();
    if (!option) return null;

    const qty = Math.max(1, parseInt(option.dataset.qty || '1', 10) || 1);
    const totalCents = parseInt(option.dataset.optionTotalCents || '', 10);

    if (Number.isFinite(totalCents) && totalCents > 0 && qty > 0) {
      return Math.round(totalCents / qty);
    }

    const discount = parseInt(option.dataset.discount || '0', 10);
    if (Number.isFinite(variantPrice) && variantPrice > 0) {
      return Math.round(variantPrice * (100 - discount) / 100);
    }

    return null;
  }

  const updateAtcPrice = () => {
    if (!priceEl) return;

    const qty = Math.max(1, parseInt(input?.value || '1', 10) || 1);
    const purchaseType = getSelectedPurchaseType();

    if (mixActive()) {
      priceEl.textContent = formatSEK(mixPriceCents());
      return;
    }

    if (purchaseType === 'subscription') {
      const unitPrice = getSubscriptionUnitPrice();
      if (unitPrice !== null) {
        priceEl.textContent = formatSEK(Math.round(unitPrice * qty));
        return;
      }
    }

    const unitCents = getSelectedOptionUnitCents();
    if (unitCents !== null) {
      priceEl.textContent = formatSEK(unitCents * qty);
      return;
    }

    const option = getSelectedOption();
    const selectedQty = option ? parseInt(option.dataset.qty || '1', 10) : qty;
    const discount = option ? parseInt(option.dataset.discount || '0', 10) : getDiscountForTier(selectedQty);
    const totalCents = Math.round(variantPrice * qty * (100 - discount) / 100);

    priceEl.textContent = formatSEK(totalCents);
  };

  function createLoaderImg(size = 24, url = LOADER_SVG_URL) {
    const img = document.createElement('img');
    img.src = url;
    img.alt = '';
    img.width = size;
    img.height = size;
    img.className = 'inline-block align-middle';
    img.setAttribute('aria-hidden', 'true');
    return img;
  }

  function createCheckIcon(size = 18) {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', String(size));
    svg.setAttribute('height', String(size));
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('inline-block', 'align-middle');

    const path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M20 6L9 17l-5-5');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2.5');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');

    svg.appendChild(path);
    return svg;
  }

  function setAtcState(state) {
    if (!atcLabel) return;

    atcLabel.innerHTML = '';

    if (state === 'adding') {
      hideAtcPrice(true);
      atcLabel.appendChild(createLoaderImg(24, PDP_LOADER_SVG_URL));
      return;
    }

    if (state === 'added') {
      hideAtcPrice(true);
      atcLabel.appendChild(createCheckIcon(18));
      return;
    }

    hideAtcPrice(false);
    atcLabel.textContent = getSelectedPurchaseType() === 'subscription'
      ? i18n.subscribe
      : i18n.addToCart;
  }

  function selectEmbedPlan(planId) {
    if (!subscriptionEmbed || !planId) return false;

    const id = String(planId);

    const radio = subscriptionEmbed.querySelector(
      `input[name="selling_plan"][value="${id}"], input[type="radio"][value="${id}"]`
    );

    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    const select = subscriptionEmbed.querySelector('select[name="selling_plan"], select');
    if (select) {
      const optionExists = Array.from(select.options || []).some((opt) => String(opt.value) === id);
      if (optionExists) {
        select.value = id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    return false;
  }

  function scheduleEmbedSelection() {
    if (!subscriptionEmbed) return;

    clearTimeout(embedSyncTimer);
    embedSyncTimer = setTimeout(() => {
      const planId = getSelectedSellingPlanId();
      if (planId) selectEmbedPlan(planId);
    }, 80);
  }

  function updatePurchaseTypeUI() {
    const type = getSelectedPurchaseType();

    if (type === 'subscription') {
      if (bundleOptions) bundleOptions.classList.add('hidden');
      if (subscriptionPanel) subscriptionPanel.classList.remove('hidden');
      if (bulkTextEl) bulkTextEl.classList.add('hidden');
      if (subTextEl) subTextEl.classList.remove('hidden');
      ensureSubscriptionSelection();
      updateAtcPrice();
      scheduleEmbedSelection();
    } else {
      if (bundleOptions) bundleOptions.classList.remove('hidden');
      if (subscriptionPanel) subscriptionPanel.classList.add('hidden');
      if (bulkTextEl) bulkTextEl.classList.remove('hidden');
      if (subTextEl) subTextEl.classList.add('hidden');
      setSellingPlan('');
    }

    syncPurchaseTypeTabOrder();
    setAtcState('normal');
    renderPicks();
    updateAtcPrice();
  }

  async function refreshCartDrawer() {
    try {
      if (window.CartDrawerAjax && typeof window.CartDrawerAjax.refresh === 'function') {
        await window.CartDrawerAjax.refresh();
        return;
      }

      const response = await fetch('/?section_id=cart-drawer&t=' + Date.now(), {
        headers: { Accept: 'text/html' },
        cache: 'no-store'
      });

      if (!response.ok) return;

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const currentDrawerInner = document.getElementById('CartDrawer');
      const newDrawerInner = doc.querySelector('#CartDrawer');

      if (currentDrawerInner && newDrawerInner) {
        currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
      }

      const cartRes = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });

      if (cartRes.ok) {
        const cart = await cartRes.json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = String(cart.item_count);
        });
      }

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { source: 'product-atc' }
      }));
    } catch (error) {
      console.error('[Cart] refresh failed:', error);
    }
  }

  function buildPayload() {
    const formData = new FormData(productForm);
    const payload = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (key === 'selling_plan' && (!value || String(value).trim() === '')) {
        continue;
      }
      payload.append(key, value);
    }

    return payload;
  }

  async function addToCart() {
    if (!productForm || isBusy) return;

    if (getSelectedPurchaseType() === 'subscription') {
      const ok = syncSubscriptionStateFromSelect();
      if (!ok) ensureSubscriptionSelection();
      scheduleEmbedSelection();
    }

    const originalLabel = getSelectedPurchaseType() === 'subscription'
      ? i18n.subscribe
      : i18n.addToCart;

    const originalDisabled = submitButton ? submitButton.disabled : false;
    isBusy = true;

    try {
      if (submitButton) submitButton.disabled = true;
      setAtcState('adding');

      // Mixed flavours: one line per chosen product
      const response = mixActive()
        ? await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: mixItems() })
        })
        : await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: buildPayload()
        });

      const json = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(json?.description || json?.message || 'Could not add to cart.');
      }

      setAtcState('added');

      await refreshCartDrawer();
      openCart();

      window.setTimeout(() => {
        updatePurchaseTypeUI();
        if (submitButton) submitButton.disabled = originalDisabled;
        isBusy = false;
      }, 2000);
    } catch (error) {
      console.error('[ATC] add to cart failed:', error);
      if (atcLabel) atcLabel.textContent = originalLabel;
      hideAtcPrice(false);
      if (submitButton) submitButton.disabled = originalDisabled;
      isBusy = false;
    }
  }

  const setQty = (value) => {
    const qty = Math.max(1, parseInt(value, 10) || 1);
    const selectedQty = getTierForQty(qty);

    if (input) input.value = qty;
    if (minus) minus.disabled = qty <= 1;

    updateActiveOption(selectedQty);
    renderPicks();
    updateAtcPrice();
  };

  function updateActiveOption(selectedQty) {
    const activeRadio = optionLabels
      .map((label) => label.querySelector('.purchase-option'))
      .find((radio) => radio && parseInt(radio.dataset.qty, 10) === selectedQty);

    syncPurchaseOptionState(activeRadio || null);
  }

  function setInitialActiveOption() {
    const initialRadio =
      radios.find((radio) => radio.checked) ||
      radios.find((radio) => parseInt(radio.dataset.qty, 10) === 1) ||
      radios[0] ||
      null;

    if (initialRadio) {
      syncPurchaseOptionState(initialRadio);
      setQty(initialRadio.dataset.qty);
      return;
    }

    if (input) {
      setQty(input.value || 1);
    }
  }

  optionLabels.forEach((label) => {
    const radio = label.querySelector('.purchase-option');
    if (!radio) return;

    if (!label.hasAttribute('tabindex')) {
      label.tabIndex = 0;
    }
    label.setAttribute('role', label.getAttribute('role') || 'radio');

    const selectOption = () => {
      radio.checked = true;
      syncPurchaseOptionState(radio);

      setPurchaseType('onetime');
      setSellingPlan('');

      setQty(radio.dataset.qty);
      updateAtcPrice();
    };

    radio.addEventListener('change', () => {
      if (!radio.checked) return;
      syncPurchaseOptionState(radio);
      setQty(radio.dataset.qty);
      updateAtcPrice();
    });

    label.addEventListener('click', (event) => {
      event.preventDefault();
      selectOption();
    });

    label.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        selectOption();
      }
    });
  });

  if (minus) {
    minus.addEventListener('click', () => {
      setQty(parseInt(input.value, 10) - 1);
    });
  }

  if (plus) {
    plus.addEventListener('click', () => {
      setQty(parseInt(input.value, 10) + 1);
    });
  }

  if (input) {
    input.addEventListener('input', () => {
      input.value = input.value.replace(/[^0-9]/g, '');
      setQty(input.value || 1);
    });

    input.addEventListener('change', () => {
      setQty(input.value || 1);
    });
  }

  purchaseTypeButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      setPurchaseType(btn.dataset.purchaseTypeBtn);
    });

    btn.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        setPurchaseType(btn.dataset.purchaseTypeBtn);
      }
    });
  });

  if (frequencySelect) {
    frequencySelect.addEventListener('change', () => {
      syncSubscriptionStateFromSelect();
      updateAtcPrice();
      scheduleEmbedSelection();
    });
  }

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (
      subscriptionEmbed &&
      subscriptionEmbed.contains(target) &&
      (
        target.matches('input[name="selling_plan"]') ||
        target.matches('input[type="radio"]') ||
        target.matches('select')
      )
    ) {
      syncSubscriptionStateFromSelect();
      updateAtcPrice();
    }
  });

  if (subscriptionEmbed) {
    const observer = new MutationObserver(() => {
      clearTimeout(embedSyncTimer);
      embedSyncTimer = setTimeout(() => {
        if (getSelectedPurchaseType() === 'subscription') {
          syncSubscriptionStateFromSelect();
          const planId = getSelectedSellingPlanId();
          if (planId) selectEmbedPlan(planId);
        }
      }, 50);
    });

    observer.observe(subscriptionEmbed, {
      childList: true,
      subtree: true
    });
  }

  if (productForm) {
    productForm.addEventListener('submit', (event) => {
      event.preventDefault();
      addToCart();
    });
  }

  if (submitButton) {
    submitButton.addEventListener('click', (event) => {
      event.preventDefault();
      addToCart();
    });
  }

  setInitialActiveOption();
  updateBundleRowPrices();
  updateAtcPrice();
  syncPurchaseTypeTabOrder();
  updatePurchaseTypeUI();
}

  /* ------------------------------------------------------------------------------------------
      CART DRAWER
  ------------------------------------------------------------------------------------------ */
  (function () {
    'use strict';

    const SECTION_NAME = 'cart-drawer';
    const SECTION_ENDPOINT = '/?sections=' + SECTION_NAME;
    const CART_CHANGE_URL = '/cart/change.js';
    const CART_JSON_URL = '/cart.js';

    const CART_SELECTOR = '#CartDrawer';
    const DRAWER_ASIDE_SELECTOR = '#cart-drawer';

    let inflightController = null;
    let overlayCount = 0;
    let disableToken = 0;

    const BATCH_DEBOUNCE_MS = 200;
    let batchTimer = null;
    const pendingChanges = new Map();

    function qs(sel, ctx = document) {
      return (ctx || document).querySelector(sel);
    }

    function qsa(sel, ctx = document) {
      return Array.from((ctx || document).querySelectorAll(sel));
    }

    function createOverlay() {
      const el = document.createElement('div');
      el.className = `
        absolute inset-0 z-[9999]
        flex items-center justify-center
        pt-0 px-2 md:px-3 pb-2 md:pb-3
      `;
      el.innerHTML = `
        <div class="flex w-full h-full rounded-md bg-white/80 items-center justify-center gap-3 text-sm font-medium">
          <svg class="animate-spin w-[35px] h-[35px]" width="35" height="35" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.7 48.2" aria-hidden="true">
            <path d="M40.6,19.8 54.3,20.4c4.6,.82,1.5,12.35,0,15.41-3.41,6.87-9.81,10.4-17.46,10.36-3.07-.02-11.95-1.54-10.64-6.01,1.10-3.76,5.07-.85,6.76-.47,9.6,2.19,17.42-3.34,17.55-13.27-.95-1.48-11.94.39-14.19-1.02-1.44-.91-1.65-5.27-2.25-7.22-2.22-7.25-8.73-14.06-16.93-11.47-9.51,3.01-12.35,15.9-10.76,24.65.35,1.93,3.43,10.75,5.51,10.75,2.94,0,5.19-11.56,5.25-14.03.07-3.10-1.84-8.81-1.51-10.90.50-3.12,4.67-3.18,6.02,.44,2.89,7.74,1.33,30.35-9.78,30.66-4.84.13-8.59-7.07-9.94-10.99C-1.55,27.14-.47,15.72,6.39,7.37c12.71-15.47,31.24-4.30,34.24,12.40Z" fill="#6a100d"/>
          </svg>
        </div>
      `;
      return el;
    }

    function showOverlayImmediate() {
      const aside = qs(DRAWER_ASIDE_SELECTOR);
      if (!aside) return;
      if (getComputedStyle(aside).position === 'static') {
        aside.style.position = 'relative';
        aside.dataset._prev_position = aside.style.position || '';
      }
      let overlay = aside.querySelector(':scope > .cart-drawer-overlay');
      if (!overlay) {
        overlay = createOverlay();
        overlay.classList.add('cart-drawer-overlay');
        aside.appendChild(overlay);
      }
      overlayCount = (overlayCount || 0) + 1;
    }

    function decOverlay() {
      const aside = qs(DRAWER_ASIDE_SELECTOR);
      if (!aside) return;
      overlayCount = Math.max((overlayCount || 0) - 1, 0);
      if (overlayCount === 0) {
        const overlay = aside.querySelector(':scope > .cart-drawer-overlay');
        if (overlay) overlay.remove();
        if (aside.dataset._prev_position !== undefined) {
          aside.style.position = aside.dataset._prev_position || '';
          delete aside.dataset._prev_position;
        }
      }
    }

    function hideOverlayForce() {
      const aside = qs(DRAWER_ASIDE_SELECTOR);
      if (!aside) return;
      const overlay = aside.querySelector(':scope > .cart-drawer-overlay');
      if (overlay) overlay.remove();
      overlayCount = 0;
      if (aside.dataset._prev_position !== undefined) {
        aside.style.position = aside.dataset._prev_position || '';
        delete aside.dataset._prev_position;
      }
    }

    function disableQtyInputs() {
      disableToken = (disableToken || 0) + 1;
      const token = disableToken;
      qsa('#CartDrawer input[name="quantity"], #CartDrawer .cart-qty').forEach(i => {
        i.setAttribute('disabled', 'disabled');
        i.dataset._wasdisabled = '1';
      });
      return token;
    }

    function enableQtyInputs(token) {
      if (token !== disableToken) return;
      qsa('#CartDrawer input[name="quantity"], #CartDrawer .cart-qty').forEach(i => {
        i.removeAttribute('disabled');
        delete i.dataset._wasdisabled;
      });
    }

    function updateCartCounts(count) {
      qsa('[data-cart-count]').forEach(el => el.textContent = count);
      const badge = document.getElementById('cart-items');
      if (badge) {
        badge.textContent = count;
        if (Number(count) === 0) {
          badge.classList.add('hidden');
          badge.setAttribute('aria-hidden', 'true');
        } else {
          badge.classList.remove('hidden');
          badge.setAttribute('aria-hidden', 'false');
        }
      }
    }

    function updateCartTotal(formatted) {
      qsa('[data-cart-total]').forEach(el => el.textContent = formatted);
    }

    async function refreshSection() {
      // showOverlayImmediate();
      const token = disableToken;
      try {
        const res = await fetch(SECTION_ENDPOINT, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) throw new Error('Section fetch failed');

        const json = await res.json();
        const keys = Object.keys(json || {});
        if (!keys.length) {
          // decOverlay();
          return;
        }

        for (const sectionId of keys) {
          const html = json[sectionId];
          if (!html) continue;
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          let target = document.getElementById(sectionId) || document.querySelector(`[data-section-id="${sectionId}"]`);
          const incomingRootById = doc.getElementById(sectionId);
          const incomingShopifySection = doc.querySelector('.shopify-section');
          const incomingRoot = incomingRootById || incomingShopifySection || doc.body.firstElementChild;

          if (target && incomingRoot) {
            target.innerHTML = incomingRoot.innerHTML;
            continue;
          }

          const commonFallbackIds = ['cart-icon-bubble', 'cart-items-bubble', 'cart-items', 'cart-count', 'cart-bubble'];
          let replaced = false;
          for (const fid of commonFallbackIds) {
            const node = document.getElementById(fid);
            if (node && incomingRoot) {
              node.innerHTML = incomingRoot.innerHTML;
              replaced = true;
              break;
            }
          }
          if (replaced) continue;

          if (incomingRoot && incomingRoot.id) {
            const node = document.getElementById(incomingRoot.id);
            if (node) {
              node.innerHTML = incomingRoot.innerHTML;
              continue;
            }
          }
        }

        let formattedTotal = null;
        if (json[SECTION_NAME]) {
          const doc2 = new DOMParser().parseFromString(json[SECTION_NAME], 'text/html');
          const ft = doc2.querySelector('[data-cart-total]');
          if (ft && ft.textContent && ft.textContent.trim()) formattedTotal = ft.textContent.trim();
        }

        const cartRes = await fetch(CART_JSON_URL, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (cartRes.ok) {
          const cart = await cartRes.json();
          updateCartCounts(cart.item_count);

          const badge = qs('#cart-items');
          if (badge) {
            badge.textContent = cart.item_count;
            if (Number(cart.item_count) === 0) {
              badge.classList.add('hidden');
              badge.setAttribute('aria-hidden', 'true');
            } else {
              badge.classList.remove('hidden');
              badge.setAttribute('aria-hidden', 'false');
            }
          }

          if (formattedTotal) {
            updateCartTotal(formattedTotal);
          } else if (window.Shopify?.formatMoney) {
            updateCartTotal(Shopify.formatMoney(cart.total_price));
          } else {
            updateCartTotal((Number(cart.total_price) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
          }
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'refreshSection' } }));
      } catch (err) {
        console.warn('Cart refresh error', err);
        // hideOverlayForce();
      } finally {
        enableQtyInputs(token);
        // decOverlay();
      }
    }

    async function executeBatch() {
      if (!pendingChanges.size) return;

      if (inflightController) {
        try { inflightController.abort(); } catch (e) {}
        inflightController = null;
      }

      inflightController = new AbortController();
      const signal = inflightController.signal;

      // showOverlayImmediate();
      const token = disableQtyInputs();

      try {
        const entries = Array.from(pendingChanges.entries());
        pendingChanges.clear();

        for (const [key, change] of entries) {
          if (signal.aborted) throw new DOMException('Aborted', 'AbortError');

          const payload = change.type === 'id'
            ? { id: change.value, quantity: change.qty }
            : { line: Number(change.value), quantity: change.qty };

          const res = await fetch(CART_CHANGE_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(payload),
            signal
          });

          if (!res.ok) {
            console.error('Cart change failed for', payload, res.status);
          } else {
            try {
              const cartJson = await res.json();
              updateCartCounts(cartJson.item_count);
            } catch (e) {
              /* ignore parse errors */
            }
          }
        }

        await refreshSection();
        document.dispatchEvent(new CustomEvent('cart:changed', { detail: { source: 'batch' } }));
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Batch execution error', err);
          // hideOverlayForce();
          enableQtyInputs(token);
        }
      } finally {
        inflightController = null;
        enableQtyInputs(token);
        // decOverlay();
      }
    }

    function scheduleBatch() {
      if (batchTimer) clearTimeout(batchTimer);
      batchTimer = setTimeout(() => {
        batchTimer = null;
        executeBatch();
      }, BATCH_DEBOUNCE_MS);
    }

    function handleQuantityChangeEvent(el) {
      const qty = parseInt(el.value, 10) || 0;
      const form = el.closest('form');
      const id = form?.querySelector('input[name="id"]')?.value;
      const line = el.dataset.line || el.closest('li[data-line]')?.dataset.line;

      if (id) {
        pendingChanges.set(`id:${id}`, { type: 'id', value: id, qty });
      } else if (line) {
        pendingChanges.set(`line:${line}`, { type: 'line', value: line, qty });
      } else {
        form?.submit();
        return;
      }

      if (inflightController) {
        try { inflightController.abort(); } catch (e) {}
        inflightController = null;
      }

      scheduleBatch();
    }

    function onChange(e) {
      const el = e.target;
      if (!el || !el.matches) return;
      if (!el.matches('input[name="quantity"], .cart-qty')) return;

      handleQuantityChangeEvent(el);
    }

    function onSubmit(e) {
      const form = e.target;
      if (!form || !(form.matches && (form.matches('form[action="/cart/change"]') || form.classList.contains('cart-qty-form')))) return;
      e.preventDefault();

      const id = form.querySelector('input[name="id"]')?.value;
      const qty = parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 0;

      if (id) {
        pendingChanges.set(`id:${id}`, { type: 'id', value: id, qty });
        if (inflightController) { try { inflightController.abort(); } catch (e) {} inflightController = null; }
        scheduleBatch();
      } else {
        const li = form.closest('li[data-line]');
        const line = li ? li.getAttribute('data-line') : null;
        if (line) {
          pendingChanges.set(`line:${line}`, { type: 'line', value: line, qty });
          if (inflightController) { try { inflightController.abort(); } catch (e) {} inflightController = null; }
          scheduleBatch();
        } else {
          form.submit();
        }
      }
    }

    document.addEventListener('change', onChange, { passive: true });
    document.addEventListener('submit', onSubmit, true);

    window.plus = function (btn) {
      const form = btn.closest("form");
      const input = form.querySelector('input[name="quantity"]');
      let value = parseInt(input.value, 10) || 0;
      input.value = value + 1;
      handleQuantityChangeEvent(input);
    };

    window.minus = function (btn) {
      const form = btn.closest("form");
      const input = form.querySelector('input[name="quantity"]');
      let value = parseInt(input.value, 10) || 0;
      if (value > 0) {
        input.value = value - 1;
        handleQuantityChangeEvent(input);
      }
    };

    window.removeItem = function (btn) {
      const li = btn.closest('li[data-line]');
      const form = btn.closest('form');

      const id = form?.querySelector('input[name="id"]')?.value;
      const line = li?.dataset.line;

      if (id) {
        pendingChanges.set(`id:${id}`, { type: 'id', value: id, qty: 0 });
      } else if (line) {
        pendingChanges.set(`line:${line}`, { type: 'line', value: line, qty: 0 });
      } else {
        const input = form?.querySelector('input[name="quantity"]');
        if (input) {
          input.value = 0;
          handleQuantityChangeEvent(input);
          return;
        }
        return;
      }

      if (inflightController) {
        try { inflightController.abort(); } catch (e) {}
        inflightController = null;
      }

      scheduleBatch();
    };

    document.addEventListener('drawer:opened', (ev) => {
      const drawer = ev.detail?.drawer;
      if (!drawer) return;
      if (drawer.id === 'cart-drawer') refreshSection();
    });

    window.CartDrawerAjax = {
      refresh: refreshSection,
      change: executeBatch,
      _debug: {
        getPending: () => Array.from(pendingChanges.entries()),
        getBatchTimer: () => !!batchTimer,
        getInflight: () => !!inflightController
      }
    };

    document.addEventListener('DOMContentLoaded', () => {
      const drawer = qs(DRAWER_ASIDE_SELECTOR);
      if (drawer && (drawer.classList.contains('is-open') || drawer.getAttribute('aria-hidden') === 'false')) {
        refreshSection();
      }
    });
  })();